import api from "./api";

export default {
  mixins: [ api ],
  methods: {
    // Получение списка рекрутинговых заявок
    async getRecruitTasks(data) {
      let params = this.makeSearchParams(data);
      let sorting = this.makeSortParams(data);

      if (data.start_opened_date) {
        const serverDate = this.getDateToServer(data.start_opened_date).toISOString();
        params.set("start_opened_date", serverDate);
      }

      if (data.end_opened_date) {
        const serverDate = this.getDateToServer(data.end_opened_date).toISOString();
        params.set("end_opened_date", serverDate);
      }

      if (data.start_closed_date) {
        const serverDate = this.getDateToServer(data.start_closed_date).toISOString();
        params.set("start_closed_date", serverDate);
      }

      if (data.end_closed_date) {
        const serverDate = this.getDateToServer(data.end_closed_date).toISOString();
        params.set("end_closed_date", serverDate);
      }

      if (data.locations) {
        data.locations.forEach(id => {
          params.append("locations[]", id);
        });
      }

      if (data.users) {
        data.users.forEach(id => {
          params.append("members[]", id);
        });
      }

      if (data.status) {
        params.set("status", data.status);
      }

      if (data.urgency !== undefined) {
        params.set("urgency", data.urgency);
      }

      if (data.assigned) {
        data.assigned.forEach(id => {
          params.append("assigned[]", id);
        });
      }

      if (data.vacancies) {
        data.vacancies.forEach(id => {
          params.append("vacancies[]", id);
        });
      }

      if (data.tags) {
        data.tags.forEach(id => {
          params.append("tags[]", id);
        });
      }

      return await this.get(`recruit_tasks?${params.toString()}${sorting}`);
    },
    // Получение рекрутинговой заявки по id
    async getRecruitTaskById(id) {
      return await this.get(`recruit_tasks/recruit_task_id/${id}`);
    },
    // Создание рекрутинговой заявки
    async postRecruitTask(data) {
      return await this.post('recruit_tasks', data);
    },
    // Изменение рекрутинговой заявки
    async putRecruitTask(data) {
      return await this.put(`recruit_tasks/recruit_task_id/${data.id}`, data);
    },
    // Удаление рекрутинговой заявки
    async deleteRecruitTask(data) {
      return await this.delete(`recruit_tasks/recruit_task_id/${data.id}`, null);
    },
    // Обновление статусов заявок
    async putRecruitTaskUpdateStatuses(data) {
      const ids = data.recruit_task_ids.map(function (item) {
        return "&recruit_task_ids[]=" + item;
      });
      const recruitTasksIds = ids.join('').substring(1);

      return await this.put(`recruit_tasks/update_statuses?status_id=${data.status_id}&${recruitTasksIds}`, data);
    },
  }
}



// WEBPACK FOOTER //
// ./src/network/recruitTasks.js